import React from 'react';

export default function Error404Page() {
  return (
    <h1>404</h1>
  );
}
